<template>
  <div class="card mb-4">
    <div class="col-12">
      <transition name="slide-fade">
        <kid-details
          v-if="isChildVisible"
          @close="hideChild"
          :kid="kid"
          :lastSeason="localLastSeason"
        />
      </transition>
      <transition name="slide-fade">
        <FormEditKid
          v-if="isEditKidVisible"
          @close-edit-form="hideEditKid"
          :kid="kid"
        />
      </transition>
    </div>
    <div class="d-flex">
      <div class="card-header pb-0">
        <h6>{{ $t("kids.kids") }}</h6>
      </div>
      <div
        class="pe-md-3 d-flex align-items-center"
        :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
      >
        <div class="me-3 mt-3">
          <form class="input-group">
            <input
              type="text"
              class="form-control back"
              v-model="searchQuery"
              :placeholder="
                this.$store.state.isRTL ? 'أكتب هنا...' : $t('kids.search')
              "
            />
          </form>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("kids.kid") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("parents.parent") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-1"
              >
                {{ $t("teachers.mobile") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 col-2"
              >
                {{ $t("kids.birthday") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.activ") }}
              </th>
              <th class="text-secondary opacity-7 col-2"></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.details") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredKids" :key="item.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="item.image"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.kid_name }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      {{ item.email }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <div class="text-center text-xs font-weight-bold mb-0">
                  {{ item.parent_object.parent_name }}
                </div>
              </td>
              <td>
                <p class="text-center text-xs font-weight-bold mb-0">
                  {{ item.mobile }}
                </p>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  item.birthday
                }}</span>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="!item.deleted_at"
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.yes") }}
                </soft-badge>
                <soft-badge
                  v-else-if="item.deleted_at"
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.no") }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <div v-if="lastSeason">
                  <div v-if="!item.deleted_at">
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editKid(item)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i
                      >{{ $t("global.edit") }}
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="deleteKid(item)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >{{ $t("global.delete") }}
                    </a>
                  </div>
                  <div v-else>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      class="mx-3"
                      @click="activateKid(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'success' : 'secondary'"
                        class="w-50"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.activate") : "" }}
                      </soft-badge>
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      @click="permanentlyDeleteKid(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'danger' : 'secondary'"
                        class="w-50"
                        variant="gradient"
                        size="sm"
                      >
                        {{ !item.valid ? $t("global.deleteForever") : "" }}
                      </soft-badge>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="#" @click="showKid(item)">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import KidDetails from "../components/KidDetails";
import FormEditKid from "@/components/FormEditKid.vue";
import axios from "axios";
import swal from "sweetalert2";

export default {
  name: "kid-list",
  props: {
    kids: {
      type: Array,
      required: true,
      default: () => [],
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
    isEditFormVisible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      kid: {},
      isChildVisible: false,
      isEditKidVisible: false,
      searchQuery: "",
      localKids: { ...this.kids },
      searchedKids: this.localKids,
      localLastSeason: this.lastSeason,
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
    KidDetails,
    FormEditKid,
  },
  watch: {
    kids(newKids) {
      this.localKids = { ...newKids };
      this.localLastSeason = this.$route.params.lastSeason
        ? Boolean(this.$route.params.lastSeason)
        : this.lastSeason;
    },
    isEditFormVisible(new_value) {
      this.isEditKidVisible = new_value;
    },
  },
  computed: {
    userRole() {
      return localStorage.getItem("userRole");
    },
    filteredKids() {
      const search = this.searchQuery.trim().toLowerCase();

      if (!search) {
        this.getSearchedKids();
        this.$emit("show-pagination");
        return this.kids;
      }

      this.$emit("hide-pagination");
      return this.searchedKids.filter((kid) => {
        return kid.kid_name.toLowerCase().includes(search);
      });
    },
  },
  methods: {
    async getSearchedKids() {
      const res = await axios.get("get-searched-kids");
      this.searchedKids = res.data.kids;
    },
    editKid(kid) {
      this.kid = kid;
      this.isEditKidVisible = true;
      this.isChildVisible = false;
      this.$emit("hide-create-form");
      this.scrollToTop();
    },
    async deleteKid(kid) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        //html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("kid/" + kid.id);
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
          });
          this.$emit("kid-updated");
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    showKid(kid) {
      this.kid = kid;
      this.isChildVisible = true;
      this.isEditKidVisible = false;
      this.scrollToTop();
    },
    hideChild() {
      this.isChildVisible = false;
    },
    hideEditKid() {
      this.isEditKidVisible = false;
      this.$emit("kid-updated", 1);
    },
    hideCreateForm() {
      //this.isChildVisible = false;
      this.isEditVisible = false;
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    },

    async activateKid(kid) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (kid.parent_object.deleted_at) {
        swal.fire({
          title: this.$t("global.error") + "!",
          text: this.$t("kids.parentDeleted"),
          icon: "error",
        });
        return;
      }
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.post("activate-kid", {
            kid: kid.id,
          });
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-kids");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.close();
        swal.fire({
          title: this.$t("global.activationCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    async permanentlyDeleteKid(kid) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("kids.kidPermanentlyDelete"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.delete(
            "permanently-delete-kid/" + kid.id
          );
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-kids");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
  },
};
</script>
